import { useEffect, useState } from "react";
import { Button, Form, Offcanvas } from "react-bootstrap";
import { FaPlusSquare, FaTrashAlt } from "react-icons/fa";
import Swal from "sweetalert2";
import { FiSearch } from "react-icons/fi";
import { TbUserShare } from "react-icons/tb";
import { sharedServices } from "../../../APIServices/PasswordManagement/sharedServices";
import { userServices } from "../../../APIServices/UserData/userServices";
import { decryptGroupKey, decryptItemKey, decryptPrivateKey, decryptSharedKey, encryptItemKey, encryptSharedKey, generateNewKey } from "../../../APIHelpers/utils";
import { useApp } from "../../../APIHelpers/AppContext";
import { groupServices } from "../../../APIServices/PasswordManagement/groupServices";
import { MdOutlineCategory, MdOutlineEmail } from "react-icons/md";
import { IoIosSend } from "react-icons/io";
import { handleResponse } from "../../../APIHelpers/Responses";
const ShareWith = ({
  Show,
  Hide,
  Title,
  itemData,
  isDark,
  currentUserData,
  auth
}) => {
  const { getVaultKey } = useApp();
  const [shareWith, setShareWith] = useState("member");
  const [expiryTime, setExpiryTime] = useState("");
  const [minDateTime, setMinDateTime] = useState("");

  const [searchMember, setSearchMember] = useState("");
  const [members, setMembers] = useState([]);
  const [memberCount, setMemberCount] = useState(0);

  const [searchGroup, setSearchGroup] = useState("");
  const [groups, setGroups] = useState([]);
  const [groupCount, setGroupCount] = useState(0);

  const [assignedMember, setAssignedMember] = useState([]);
  const [assignedGroup, setAssignedGroup] = useState([]);

  const [emails, setEmails] = useState([]);
  const [loader, setLoader] = useState(false);

  const getMembers = async () => {
    let data = await userServices.getMembers(auth, "active", searchMember);
    setMembers(data?.data || []);
    setMemberCount(data?.count)
  };

  const getTotalGroupList = async () => {
    let data = await groupServices.getGroupList(auth, "total", searchGroup);
    let result = (data?.data || [])?.filter(item => item.groupId != itemData?.groupId)
    let count = (data?.data || [])?.length - result?.length
    setGroups(result);
    setGroupCount(data?.count - count)
  };

  const validateDuplicateEmails = (list) => {
    const countMap = {};

    list.forEach(item => {
      const key = item.email.trim().toLowerCase();
      if (!key) return;
      countMap[key] = (countMap[key] || 0) + 1;
    });

    return list.map(item => {
      const key = item.email.trim().toLowerCase();
      if (key && countMap[key] > 1) {
        return { ...item, error: "Duplicate Email, Please remove it" };
      }
      return { ...item, error: "" };
    });
  };

  const handleChange = (index, value) => {
    setEmails(prev => {
      const updated = [...prev];
      updated[index] = { ...updated[index], email: value };
      return validateDuplicateEmails(updated);
    });
  };

  const handleAdd = () => {
    setEmails(prev => [...prev, { email: "", userId: "", publicKey: "", error: "" }]);
  };

  const handleDelete = (email) => {
    setEmails(prev =>
      prev.filter(item => item.email !== email)
    );
  };

  const toggleMember = (userId) => {
    const member = members.find((m) => m.userId === userId);
    if (!member) return;
    setAssignedMember((prev) => {
      const exists = prev.find((p) => p.userId === userId);
      if (exists) {
        return prev.filter((p) => p.userId !== userId);
      } else {
        return [...prev, { userId: member.userId, publicKey: member.publicKey }];
      }
    });
  };

  const handleMemberSelectAll = (checked) => {
    if (checked) {
      const all = members.map((m) => ({ userId: m.userId, publicKey: m.publicKey }));
      setAssignedMember(all);
    } else {
      setAssignedMember([]);
    }
  };

  const toggleGroup = (groupId) => {
    const group = groups.find((m) => m.groupId === groupId);
    if (!group) return;
    setAssignedGroup((prev) => {
      const exists = prev.find((p) => p.groupId === groupId);
      if (exists) {
        return prev.filter((p) => p.groupId !== groupId);
      } else {
        return [...prev, { groupId: group.groupId, groupKey: group.groupKey, groupKeyIV: group.groupKeyIV, sharedKey: group.sharedKey || "" }];
      }
    });
  };

  const handleGroupSelectAll = (checked) => {
    if (checked) {
      const all = groups.map((m) => ({ groupId: m.groupId, groupKey: m.groupKey, groupKeyIV: m.groupKeyIV, sharedKey: m.sharedKey || "" }));
      setAssignedGroup(all);
    } else {
      setAssignedGroup([]);
    }
  };

  const shareItemInternalUser = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to share this item of selected members?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, share it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoader(true);
        let totalSharedKeys = []
        const sharedAt = new Date();
        for (const element of assignedMember) {
          let sharedKey = await generateNewKey()
          let encryptedSharedKey = await encryptSharedKey(sharedKey, element?.publicKey)
          let decryptedItemKey = await decryptItemKey(itemData?.itemKey, itemData?.itemKeyIV, getVaultKey())
          let { encryptedItemKey, itemKeyIV } = await encryptItemKey(decryptedItemKey, sharedKey)
          const objectData = {
            scope: "item",
            isRevoked: false,
            sharedWith: element?.userId,
            sharedKey: encryptedSharedKey,
            itemKey: encryptedItemKey,
            itemKeyIV: itemKeyIV,
            expiryAt: new Date(expiryTime),
            sharedAt: sharedAt,
          };
          totalSharedKeys.push(objectData)
        }
        let userData = {
          sharedId: Math.random().toString().substr(2, 10),
          itemId: itemData?.itemId,
          adminId: itemData?.adminId,
          accountId: itemData?.accountId,
          sharedBy: currentUserData?.userId,
          categoryId: itemData?.categoryId,
          sharedKeys: totalSharedKeys,
        }
        const data = await sharedServices.shareItemInternalUser(auth, userData);
        if (data?.statusCode === 200) {
          setExpiryTime("");
          setAssignedMember([])
          Hide()
        }
        setLoader(false);
      }
    });
  };

  const shareItemMultiGroup = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to share this item of selected groups?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, share it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoader(true);
        let totalSharedKeys = []
        const sharedAt = new Date();
        for (const element of assignedGroup) {
          let encryptedItem
          if (element?.sharedKey) {
            let decryptedPrivateKey = await decryptPrivateKey(currentUserData?.privateKey, currentUserData?.privateKeyIV, getVaultKey())
            let decryptedSharedKey = await decryptSharedKey(element?.sharedKey, decryptedPrivateKey)
            let decryptedGroupKey = await decryptGroupKey(element?.groupKey, element?.groupKeyIV, decryptedSharedKey)

            let decryptedItemKey = await decryptItemKey(itemData?.itemKey, itemData?.itemKeyIV, getVaultKey())
            encryptedItem = await encryptItemKey(decryptedItemKey, decryptedGroupKey)
          } else {
            let decryptedSharedGroupKey = await decryptGroupKey(element?.groupKey, element?.groupKeyIV, getVaultKey())
            let decryptedItemKey = await decryptItemKey(itemData?.itemKey, itemData?.itemKeyIV, getVaultKey())
            encryptedItem = await encryptItemKey(decryptedItemKey, decryptedSharedGroupKey)
          }
          const objectData = {
            sharedId: Math.random().toString().substr(2, 10),
            itemId: itemData?.itemId,
            groupId: element?.groupId,
            adminId: itemData?.adminId,
            accountId: itemData?.accountId,
            sharedBy: currentUserData?.userId,
            isRevoked: false,
            itemKey: encryptedItem?.encryptedItemKey,
            itemKeyIV: encryptedItem?.itemKeyIV,
            expiryAt: new Date(expiryTime),
            sharedAt: sharedAt,
          };
          totalSharedKeys.push(objectData)
        }
        let userData = {
          sharedData: totalSharedKeys,
          categoryId: itemData?.categoryId,
          adminId: itemData?.adminId,
          accountId: itemData?.accountId,
        }
        const data = await sharedServices.shareItemMultiGroup(auth, userData);
        if (data?.statusCode === 200) {
          setExpiryTime("");
          setAssignedMember([])
          Hide()
        }
        setLoader(false);
      }
    });
  };

  const checkRegistredUser = async (emails) => {
    let data = await userServices.checkRegistredUser(auth, { emails })
    setEmails(data?.data || [])
    return data?.data || []
  }

  const sendNotificationForRegistration = async (email) => {
    let data = await userServices.sendNotificationForRegistration(auth, { email })
    if (data?.statusCode === 200) {
      setEmails(prev =>
        prev.filter(item => item.email !== email)
      );
    }
  }

  const shareItemExternalUser = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to share this item of this emails?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, share it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoader(true);
        let totalEmails = await checkRegistredUser(emails)
        let checkTotalEmail = totalEmails.some(item => item.error || !item.email?.trim())
        if (checkTotalEmail) {
          setLoader(false);
          handleResponse({
            statusCode: 400,
            customMessage: "Email not registred, Please sent Notification for registration"
          })
        } else {
          let totalSharedKeys = []
          const sharedAt = new Date();
          for (const element of totalEmails) {
            let sharedKey = await generateNewKey()
            let encryptedSharedKey = await encryptSharedKey(sharedKey, element?.publicKey)
            let decryptedItemKey = await decryptItemKey(itemData?.itemKey, itemData?.itemKeyIV, getVaultKey())
            let { encryptedItemKey, itemKeyIV } = await encryptItemKey(decryptedItemKey, sharedKey)
            const objectData = {
              scope: "item",
              isRevoked: false,
              sharedWith: element?.userId,
              sharedKey: encryptedSharedKey,
              itemKey: encryptedItemKey,
              itemKeyIV: itemKeyIV,
              expiryAt: new Date(expiryTime),
              sharedAt: sharedAt,
            };
            totalSharedKeys.push(objectData)
          }
          let userData = {
            sharedId: Math.random().toString().substr(2, 10),
            itemId: itemData?.itemId,
            adminId: itemData?.adminId,
            accountId: itemData?.accountId,
            sharedBy: currentUserData?.userId,
            categoryId: itemData?.categoryId,
            sharedKeys: totalSharedKeys,
          }
          const data = await sharedServices.shareItemInternalUser(auth, userData);
          if (data?.statusCode === 200) {
            setExpiryTime("");
            setEmails([])
            Hide()
          }
          setLoader(false);
        }
      }
    });
  };

  useEffect(() => {
    if (itemData) {
      setAssignedMember(itemData?.assignedUser || []);
    }
  }, [itemData]);

  useEffect(() => {
    if (Show) {
      getMembers();
    }
  }, [auth, searchMember, Show]);

  useEffect(() => {
    if (Show) {
      getTotalGroupList();
    }
  }, [auth, searchGroup, Show]);

  const RadioCard = ({ icon, label, active, onClick }) => (
    <div
      onClick={onClick}
      className={`p-2 rounded-2 border CP mb-2 w-100 text-center ${active ? "border-primary bg-primary bg-opacity-10" : "border-secondary"}`}
      style={{ fontSize: 12, fontWeight: 600 }}
    >
      {icon} {label}
    </div>
  );

  const getNowLocalDateTime = () => {
    const now = new Date();
    const offset = now.getTimezoneOffset() * 60000;
    return new Date(now - offset).toISOString().slice(0, 16);
  };

  const handleExpiryChange = (e) => {
    const selectedValue = e.target.value;
    const selectedDate = new Date(selectedValue);
    const now = new Date();
    if (selectedDate < now) {
      setExpiryTime(getNowLocalDateTime());
      return;
    }
    setExpiryTime(selectedValue);
  };

  useEffect(() => {
    const updateTime = () => {
      const nowLocal = getNowLocalDateTime();
      setMinDateTime(nowLocal);
      setExpiryTime(prev =>
        prev && prev < nowLocal ? nowLocal : prev
      );
    };
    updateTime();
    const interval = setInterval(updateTime, 60000);
    return () => clearInterval(interval);
  }, []);
  
  useEffect(() => {
    if(Show){
      setShareWith("member")
    }
  }, [Show]);

  const hasError = emails.some(item => item.error || !item.email?.trim())

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end" style={{ width: 560 }}>
      <Offcanvas.Header
        closeButton
        className={`${isDark ? "bg-dark" : "bg-light"} p-3 border-bottom`}
      >
        <Offcanvas.Title className="fw-bold hstack gap-2" style={{ fontSize: 15 }}>
          <img
            src={itemData?.categoryIcon}
            alt={itemData?.categoryName}
            style={{
              width: 25,
              height: 25,
              objectFit: "contain",
            }}
          />
          <span>Share {itemData?.categoryName}</span>
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <Form.Group className="mb-2">
          <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
            Share with <span className="text-danger">*</span>
          </Form.Label>
          <div className="hstack gap-2">
            <RadioCard
              icon={<TbUserShare className="me-1" />}
              label="Share with Members"
              active={shareWith === "member"}
              onClick={() => setShareWith("member")}
            />
            {itemData?.groupId !== "personal" &&
              <RadioCard
                icon={<MdOutlineCategory className="me-1" />}
                label="Share with Groups"
                active={shareWith === "group"}
                onClick={() => setShareWith("group")}
              />
            }
            <RadioCard
              icon={<MdOutlineEmail className="me-1" />}
              label="Share with Anyone"
              active={shareWith === "anyone"}
              onClick={() => setShareWith("anyone")}
            />
          </div>
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
            Expiry Time
          </Form.Label>
          <Form.Control
            type="datetime-local"
            value={expiryTime}
            min={minDateTime}
            onChange={handleExpiryChange}
            className="interactive-input rounded-1"
            style={{ fontSize: 12, padding: "6px 10px" }}
          />
        </Form.Group>
        {shareWith === "member" && (
          <>
            <Form.Group className="mb-3 position-relative">
              <FiSearch className="position-absolute" style={{ top: 8, left: 10, zIndex: 99 }} />
              <Form.Control
                type="search"
                onChange={(e) => setSearchMember(e.target.value)}
                value={searchMember}
                disabled={memberCount === 0}
                placeholder="Search Member Here..."
                className="interactive-input rounded-1"
                style={{ fontSize: 12, padding: "6px 15px 6px 35px" }}
              />
            </Form.Group>
            <div className="overflow-auto" style={{ height: "calc(100vh - 334px)" }}>
              {members?.length > 0 && (
                <Form.Check
                  type="checkbox"
                  label="Select All"
                  checked={assignedMember.length === members.length}
                  onChange={(e) => handleMemberSelectAll(e.target.checked)}
                  style={{ fontSize: 12 }}
                  className="mb-2"
                />
              )}
              <div className="d-grid gap-2">
                {members?.map((m) => (
                  <div
                    key={m.userId}
                    onClick={() => toggleMember(m.userId)}
                    className={`CP hstack gap-1`}
                    style={{ fontSize: 12, cursor: "pointer" }}
                  >
                    <span className="text-primary">
                      <Form.Check
                        type="checkbox"
                        checked={assignedMember.some((p) => p.userId === m.userId)}
                        readOnly
                      />
                    </span>
                    {m.name}
                  </div>
                ))}
              </div>
            </div>
          </>
        )}
        {(shareWith === "group" && itemData?.groupId !== "personal") && (
          <>
            <Form.Group className="mb-3 position-relative">
              <FiSearch className="position-absolute" style={{ top: 8, left: 10, zIndex: 99 }} />
              <Form.Control
                type="search"
                onChange={(e) => setSearchGroup(e.target.value)}
                value={searchGroup}
                disabled={groupCount === 0}
                placeholder="Search Group Here..."
                className="interactive-input rounded-1"
                style={{ fontSize: 12, padding: "6px 15px 6px 35px" }}
              />
            </Form.Group>
            {groups?.length > 0 && (
              <Form.Check
                type="checkbox"
                label="Select All"
                checked={assignedGroup.length === groups.length}
                onChange={(e) => handleGroupSelectAll(e.target.checked)}
                style={{ fontSize: 12 }}
                className="mb-2"
              />
            )}

            <div className="d-grid gap-2">
              {groups?.map((m) => (
                <div
                  key={m.groupId}
                  onClick={() => toggleGroup(m.groupId)}
                  className={`CP hstack gap-1`}
                  style={{ fontSize: 12, cursor: "pointer" }}
                >
                  <span className="text-primary">
                    <Form.Check
                      type="checkbox"
                      checked={assignedGroup.some((p) => p.groupId === m.groupId)}
                      readOnly
                    />
                  </span>
                  {m.groupName}
                </div>
              ))}
            </div>
          </>
        )}
        {shareWith === "anyone" && (
          <Form.Group className="mb-2">
            <Form.Label className="fw-bold mb-1 hstack gap-2" style={{ fontSize: 13 }}>
              Emails
              <FaPlusSquare title="Add Email" size={13} className="CP" onClick={handleAdd} />
            </Form.Label>

            {emails.map((item, index) => (
              <div key={index} className="mb-2">
                <div className="hstack gap-2">
                  <Form.Control
                    value={item.email}
                    placeholder={`Enter Email ${index + 1}`}
                    onChange={(e) => handleChange(index, e.target.value)}
                    className="interactive-input rounded-1"
                    isInvalid={!!item.error}
                    style={{ fontSize: 12, padding: "6px 15px" }}
                  />
                  {item?.error === "Email not registred, Please sent Notification for registration" ?
                    <IoIosSend
                      className="text-primary CP"
                      style={{ fontSize: 16 }}
                      title="Send Mail"
                      onClick={() => sendNotificationForRegistration(item.email)}
                    />
                    :
                    <FaTrashAlt
                      className="text-danger CP"
                      style={{ fontSize: 14 }}
                      title="Delete Email"
                      onClick={() => handleDelete(item.email)}
                    />
                  }
                </div>

                {item.error && (
                  <div className="text-danger mt-1" style={{ fontSize: 11 }}>
                    {item.error}
                  </div>
                )}
              </div>
            ))}

          </Form.Group>
        )}
      </Offcanvas.Body>

      <div
        className={`${isDark ? "bg-dark" : "bg-light"} p-2 border-top text-end`}
      >
        {shareWith === "anyone" && (
          <Button
            variant="outline-primary"
            style={{ fontSize: 13 }}
            disabled={!expiryTime || !emails?.length === 0 || loader || hasError}
            onClick={shareItemExternalUser}
          >
            {Title}
          </Button>
        )}
        {shareWith === "member" && (
          <Button
            onClick={shareItemInternalUser}
            variant="outline-primary"
            disabled={loader || !expiryTime}
            style={{ fontSize: 13 }}
          >
            {Title}
          </Button>
        )}
        {(shareWith === "group" && itemData?.groupId !== "personal") && (
          <Button
            onClick={shareItemMultiGroup}
            variant="outline-primary"
            disabled={loader || !expiryTime}
            style={{ fontSize: 13 }}
          >
            {Title}
          </Button>
        )}
      </div>
    </Offcanvas>
  );
};

export default ShareWith;
